import { NgTemplateOutlet, SlicePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { PaymentMethod, PaymentMethodType } from '@galaxy/billing';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [NgTemplateOutlet, MatIconModule, SlicePipe, TranslateModule],
  selector: 'smb-invoicing-payment-method-display',
  styleUrls: ['./payment-method-display.component.scss'],
  templateUrl: './payment-method-display.component.html',
})
export class PaymentMethodDisplayComponent {
  PaymentMethodType = PaymentMethodType;

  @Input() paymentMethod: PaymentMethod;

  readonly CARD_BRAND_TO_ICON_SRC = {
    Visa: 'https://vstatic-prod.apigateway.co/partner-center-client/assets/images/icons/visa.png',
    'American Express': 'https://vstatic-prod.apigateway.co/partner-center-client/assets/images/icons/amex.png',
    Mastercard: 'https://vstatic-prod.apigateway.co/partner-center-client/assets/images/icons/mastercard.png',
    Discover: 'https://vstatic-prod.apigateway.co/partner-center-client/assets/images/icons/discover.png',
  };
}
